import PropTypes from 'prop-types'

// Unité de production telle que renvoyée par productionUnit/ (ProductionUnitOutput côté back),
// enrichie des champs dérivés posés à la réception (cf. toProductionUnit).
export const ProductionUnitShape = PropTypes.shape({
    id: PropTypes.number, // Int
    code: PropTypes.string, // Option[String]
    name: PropTypes.string, // Option[String]
    productionUnitType: PropTypes.number, // Option[Int]
    directUsage: PropTypes.number, // Option[Int]
    waterNature: PropTypes.number, // Option[Int]
    controlFrequency: PropTypes.number, // Option[Int]
    realisedFrequency: PropTypes.number, // Option[Int]
    decretFrequency: PropTypes.number, // Option[Int]
    description: PropTypes.string, // Option[String]
    startDate: PropTypes.number, // Option[DateTime]
    authorizedFlow: PropTypes.number, // Option[Double]
    annualWaterAmountExploited: PropTypes.number, // Option[Double]
    perimeter: PropTypes.string, // Option[String]
    nbStationInService: PropTypes.number, // Option[Int]
    comments: PropTypes.string, // Option[String]
    contextType: PropTypes.number, // Option[Int]
    hydrogeologicalEntity: PropTypes.number, // Option[Int]
    captive: PropTypes.string, // Option[String]
    aquiferType: PropTypes.number, // Option[Int]
    watershedArea: PropTypes.number, // Option[Double]
    watermass: PropTypes.number, // Option[Int]
    hydrographicZone: PropTypes.string, // Option[String]
    hydrographicContextDescription: PropTypes.string, // Option[String]
    owner: PropTypes.number, // Option[Double]
    exploitationCode: PropTypes.number, // Option[Double]
    x: PropTypes.number, // Option[Double]
    y: PropTypes.number, // Option[Double]
    projection: PropTypes.number, // Option[Double]
    mnemonic: PropTypes.string, // Option[String]
    townCode: PropTypes.string, // Option[String]
    declarationTownCode: PropTypes.string, // Option[String]
    prefectoralArrestDate: PropTypes.number, // Option[DateTime]
    arrestDuration: PropTypes.number, // Option[Int]
    volumeAllowDay: PropTypes.number, // Option[Double]
    statusCode: PropTypes.number, // Option[Int]
    max3hCapacity: PropTypes.number, // Option[Double]
    dataOrigin: PropTypes.string, // Option[String]
    status: PropTypes.number, // Option[Int]
    statusLogin: PropTypes.string, // Option[String]
    statusDate: PropTypes.number, // Option[DateTime]
    builtArea: PropTypes.number, // Option[Double]
    nonBuiltArea: PropTypes.number, // Option[Double]
    renovationDate: PropTypes.number, // Option[DateTime]
    sector: PropTypes.number, // Option[Long]
    contributors: PropTypes.arrayOf(PropTypes.shape({})), // Option[Seq[StationContributorLink]]
    compliance: PropTypes.string, // Option[String] — pastille de conformité qualité

    // Champs dérivés côté front
    typeName: PropTypes.string,
    localisation: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        z: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        projection: PropTypes.number,
    }),
    headers: PropTypes.arrayOf(PropTypes.string),
})
